import React, { useEffect, useState } from "react";
import styles from "./SingleApplicationPage.module.scss";
import { Link, useLocation, useParams } from "react-router-dom";
import ApplyModalSVG from "../../images/SVG/ApplyModalSVG.svg";
import NoOfApplicantsComponent from "../../components/UI/NoOfApplicantsComponent/NoOfApplicantsComponent";
import ReportModal from "../../components/UI/ReportModal/ReportModal";
// import SaveSVG from "../../components/SVGComponents/SaveSVG";
// import ShareSVG from "../../components/SVGComponents/ShareSVG";
import ThreeDotsSVG from "../../components/SVGComponents/ThreeDotsSVG";
import OpeningsSVG from "../../components/SVGComponents/OpeningsSVG";
import IndustrySVG from "../../components/SVGComponents/IndustrySVG";
import LocationSVG from "../../components/SVGComponents/LocationSVG";
// import DurationSVG from "../../components/SVGComponents/DurationSVG";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationbyID } from "../../reducer/projectsSlice";
import Modal from "../../components/Modal/Modal";
import Button from "../../components/UI/Button/Button";
// import cardLogo from "../../images/Card_Logo.png";
// import SpinnerLoader from "../../components/UI/SpinnerLoader/SpinnerLoader";
import ShortlistedComponent from "../../components/UI/ShortlistedComponent/ShortlistedComponent";
import FlagSVG from "../../components/SVGComponents/FlagSVG";
// import DeleteSVG from "../../components/SVGComponents/DeleteSVG";
import { FaRegEdit } from "react-icons/fa";
import { serverFiles } from "../../utils/utils";
import SingleProjectSkeleton from "pages/SingleProjectPage/SingleProjectSkeleton";
import DurationSVG from "components/SVGComponents/DurationSVG";
import SandClockSVG from "components/SVGComponents/SandClockSVG";

const SingleProjectPage = () => {
  const { project } = useSelector((state) => state.projects);
  const { userProfile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  const { projectId } = useParams();
  const { pathname } = useLocation();

  //=================== STATES ====================
  const [reportModal, setReportModal] = useState(false);
  const [threeDotsPopup, setThreeDotsPopup] = useState(false);
  const [appliedModal, setAppliedModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  // const [saved, setSaved] = useState(false);

  // console.log(projects);

  // ==============================================================
  //                  Start and End Dates
  // ==============================================================
  // const startDate = new Date(project?.startDate).toLocaleDateString("en-GB", {
  //   day: "2-digit",
  //   month: "long",
  //   year: "numeric",
  // });
  // const endDate = new Date(project?.endDate).toLocaleDateString("en-GB", {
  //   day: "2-digit",
  //   month: "long",
  //   year: "numeric",
  // });

  const shortListedAt = new Date(project?.shortlistedAt).toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }
  );
  const appliedAt = new Date(project?.createdAt).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    dispatch(getApplicationbyID(projectId));
  }, [dispatch, projectId]);

  // if (!project)
  //   return (
  //     <div
  //       style={{
  //         height: "100vh",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         background: "#fcfdfd",
  //       }}
  //     >
  //       <SpinnerLoader />
  //     </div>
  //   );

  return (
    <>
      {project ? (
        <>
          <section className={styles.single_project_page}>
            {/* TOP TITLE */}
            {/* <section className={styles.single_project_page_heading}>
          <p>{project?.jobTitle}</p>
        </section> */}

            {/* DETAILS SECTION */}
            <section className={styles.single_project_details}>
              {/* DETAILS - TOP CATEGORY SECTION */}
              <section className={styles.single_project_category_days}>
                <div className={styles.single_project_category_left}>
                  {project?.shortlistedAt !== null ? (
                    <ShortlistedComponent
                      date={
                        shortListedAt === "Invalid Date" ? "" : shortListedAt
                      }
                    />
                  ) : (
                    // <ShortlistedComponent
                    //   date={appliedAt === "Invalid Date" ? "" : appliedAt}
                    // />

                    <p className={styles.applied_At_date}>
                      Applied on {appliedAt}
                    </p>
                  )}

                  {/* <DaysLeftComponent day={2} /> */}
                  <NoOfApplicantsComponent
                    applicants={
                      project?.applicantCount ? project?.applicantCount : 0
                    }
                  />
                  {/* <SaveSVG
                jobId={project?.jobId}
                saved={saved || project?.isSaved}
                setSaved={setSaved}
                height={24}
                width={24}
              /> */}

                  {/* <ShareSVG
                    shareModal={shareModal}
                    setShareModal={setShareModal}
                    height={24}
                    width={24}
                  /> */}
                </div>

                {/* RIGHT 3 DOTS */}
                <div className={styles.single_project_category_right}>
                  <ThreeDotsSVG
                    height={24}
                    width={24}
                    onClick={() => {
                      setThreeDotsPopup(true);
                    }}
                  />

                  {threeDotsPopup && (
                    <>
                      <div
                        className={styles.dropdown_overlay}
                        onClick={() => setThreeDotsPopup(false)}
                      />

                      <section className={styles.three_dots_popup}>
                        {userProfile?.userType === "BUSINESS" ? (
                          <>
                            {/* <div
                          className={styles.single_btn_section}
                          onClick={() => handleDeleteProject(project?.jobId)}
                        >
                          <DeleteSVG height={18} width={18} />
                          <p className={styles.single_button}>Delete</p>
                        </div> */}

                            <Link
                              to={`/projects/edit-project/${projectId}`}
                              className="unstyledLink"
                            >
                              <div className={styles.single_btn_section}>
                                <FaRegEdit
                                  height={20}
                                  width={20}
                                  fontWeight={10}
                                  color="#6570FC"
                                />
                                <p className={styles.single_button}>
                                  Edit this project
                                </p>
                              </div>
                            </Link>
                          </>
                        ) : (
                          <>
                            <div
                              onClick={() => {
                                setReportModal(true);
                                setThreeDotsPopup(false);
                              }}
                              className={styles.single_btn_section}
                            >
                              <FlagSVG height={18} width={18} color="black" />
                              <p className={styles.single_button}>
                                Report this project
                              </p>
                            </div>
                          </>
                        )}
                      </section>
                    </>
                  )}

                  <ReportModal
                    type="Project"
                    id={project?.jobId}
                    reportModal={reportModal}
                    setReportModal={setReportModal}
                  />
                </div>
              </section>

              {/* DETAILS - TITLE, IMAGE SECTION */}
              <section className={styles.single_project_title_section}>
                <div>
                  <p className={styles.single_project_title}>
                    {project?.jobTitle}
                  </p>
                  <p className={styles.single_project_company_name}>
                    {project?.name || project?.company?.name}
                  </p>
                </div>
                <div className={styles.single_project_logo}>
                  <img src={serverFiles(project?.logo)} alt="" />
                </div>
              </section>

              {/* DETAILS - BUDGET LOCATION SECTION */}
              <section className={styles.details_budget_location}>
                <div className={styles.project_openings}>
                  <OpeningsSVG height={28} width={28} />
                  <div>
                    <p className={styles.project_openings_label}>Openings</p>
                    <p className={styles.project_openings_number}>
                      {project?.noOfOpenings}
                    </p>
                  </div>
                </div>
                {/* <div className={styles.project_budget}>
              <BudgetSVG height={28} width={28} />
              <div>
                <p className={styles.project_budget_label}>Budget</p>
                <p className={styles.project_budget_number}>
                  {formatToINRCurrency(project?.projectBudget)}
                </p>
              </div>
            </div> */}

                <div className={styles.project_industry}>
                  <IndustrySVG height={28} width={28} />
                  <div>
                    <p className={styles.project_industry_label}>Work Title</p>
                    <p className={styles.project_industry_details}>
                      {/* {project?.category?.name ? project?.category?.name : "None"} */}
                      {project?.industry?.length
                        ? project?.industry?.join(", ")
                        : "None"}
                    </p>
                  </div>
                </div>
                <div className={styles.project_location}>
                  <LocationSVG height={28} width={28} />

                  <div>
                    <p className={styles.project_location_label}>Location</p>
                    <p className={styles.project_location_details}>
                      {project?.city?.name}, {project?.state?.name}
                    </p>
                  </div>
                </div>

                <div className={styles.project_duration}>
                  <SandClockSVG height={28} width={28} />

                  <div>
                    <p className={styles.project_duration_label}>
                      Project Duration
                    </p>
                    <p className={styles.project_duration_details}>
                      {project?.projectDuration
                        ? `${project?.projectDuration} day${
                            project?.projectDuration > 1 ? "s" : ""
                          }`
                        : "0 days"}
                    </p>
                  </div>
                </div>

                {/* <div className={styles.project_duration}>
              <DurationSVG height={28} width={28} />

              <div>
                <p className={styles.project_duration_label}>Duration</p>
                <p className={styles.project_duration_details}>
                  {startDate} to {endDate}
                </p>
              </div>
            </div> */}
              </section>

              {/* DETAILS - MEDIA SECTION */}
              {/* {project?.media.length > 0 ? (
            <section className={styles.media_section}>
              <p className={styles.media_section_title}>Media</p>

              <div className={styles.media_images}>
                {project?.media?.map((item, index) => (
                  <img src={item} alt="" key={index}></img>
                  // <p>{item}</p>
                ))}
              </div>
            </section>
          ) : (
            <></>
          )} */}

              {/* DETAILS - ABOUT THE PROJECT */}
              <section className={styles.details_about_this_project}>
                <p className={styles.details_about_this_project_heading}>
                  About this project
                </p>

                <div>
                  {/* {parse(project?.description)} */}
                  {/* {project?.description} */}
                  <div
                    className="ql-editor"
                    dangerouslySetInnerHTML={{ __html: project?.description }}
                  />
                </div>
              </section>

              {/* DETAILS - SKILLS REQUIRED */}
              <section className={styles.details_skills_section}>
                <p className={styles.details_skills_heading}>Skills required</p>

                <div className={styles.details_skills}>
                  {project?.skillsRequired?.map((skill, i) => (
                    <p key={i} className={styles.details_skills_skill}>
                      {skill}
                    </p>
                  ))}
                </div>
              </section>

              {/* DETAILS - APPLY BUTTON */}
              <section className={styles.details_apply_button}>
                {/* {!applied ? (
              <button className={styles.apply_button} onClick={handleApplyNow}>
                Apply Now
              </button>
            ) : (
              <>
              </>
            )} */}
                <button className={styles.applied_button}>Applied</button>
              </section>
            </section>
          </section>

          {shareModal && (
            <Modal
              modalOpen={shareModal}
              onClose={() => setShareModal((prev) => !prev)}
            >
              <h2>Share</h2>
            </Modal>
          )}

          {appliedModal && (
            <Modal
              onClose={() => setAppliedModal((prev) => !prev)}
              modalOpen={appliedModal}
            >
              <div className={styles.apply_modal_main}>
                <div className={styles.apply_modal_image}>
                  <img src={ApplyModalSVG} alt="" />
                </div>

                <div className={styles.apply_modal_details}>
                  <p className={styles.apply_modal_title}>
                    Application Submitted
                  </p>
                  <p className={styles.apply_modal_description}>
                    You can monitor the progress in My Applications
                  </p>

                  <div className={styles.apply_modal_buttons}>
                    <Link to="/projects" className={`unstyledLink`}>
                      <Button variant={"outlined"}>Continue Applying</Button>
                    </Link>

                    <Link className="unstyledLink" to="/my-applications">
                      <Button
                        className={styles.apply_modal_applications_btn}
                        variant={"filled"}
                      >
                        My Applications
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Modal>
          )}
        </>
      ) : (
        <SingleProjectSkeleton />
      )}
    </>
  );
};

export default SingleProjectPage;
